import { Component, Input } from '@angular/core';
import { CuentasBancarias } from '../ctas';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { InfoCuentasDialog } from '../info-cuentas-dialog/info-cuentas-dialog';
import { SettingsService } from '../../../settings/settings.service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatLabel } from '@angular/material/form-field';



@Component({
    selector: 'deleteacc-component',
    templateUrl: './deleteacc.component.html',
    styleUrls: ['./deleteacc.component.less'],
    standalone: true,
    imports: [
      CommonModule,
      MatDialogModule,
      MatButtonModule,
      MatLabel
    ]
})
export class CompanyDeleteAccDialog {
  id_acc: any;
  public info!: CuentasBancarias;
  showSpinner: boolean = false;
  disabled: boolean = false;

  @Input() id_company: any;
  @Input() token: any;

  constructor(
    public snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<CompanyDeleteAccDialog>,
    public dialog: MatDialog,
    public settings: SettingsService,
  ) {}

  async delete_add() {

    this.showSpinner = true;
    this.disabled = true;

      try {

        const bd: any = await this.settings.get_query(4, '/account/' + this.id_acc + '/');
        var body_data: any = bd._body;
        switch (bd.status) {
          case 201:
          case 200:
      
              this.showSpinner = false;
              this.disabled = false;
              // let sb = this.snackBar.open('¡Cuenta bancaria eliminada!', 'Aceptar', {
              //   duration: 3000,
              //   panelClass: ['simpli-snack'],
              // });

              this.infoCuentasDialog(
                "Cuenta eliminada",
                "check_circle",
                "Aceptar",
                "Se eliminó la cuenta bancaria.",
              );

              this.info.reloadAccounts();
              this.dialogRef.close('Y');
  
  
          break;
          default:
  
          break;
        }
  
      } catch (bd:any) {
        console.log(bd.error);
        this.showSpinner = false;
        this.disabled = false;
        this.infoCuentasDialog(
          "Error al eliminar la cuenta",
          "cancel",
          "Aceptar",
          "Hubo un error al eliminar la cuenta bancaria, por favor intente de nuevo.",
          true
        );
      }

  }

    infoCuentasDialog(title:any,icon:any,buttonText:any, message?:any, isError?: any) {
      const dialogRef = this.dialog.open(InfoCuentasDialog, {
        width: '700px',
        disableClose: true,
        panelClass: 'custom-dialog',
        autoFocus: false,
      });
      dialogRef.componentInstance.title = title;
      dialogRef.componentInstance.icon = icon;
      dialogRef.componentInstance.buttonText = buttonText;
      dialogRef.componentInstance.message = message;
      dialogRef.componentInstance.isError = isError;
      dialogRef.afterClosed().subscribe((result) => {
      });
    }

}
